import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {StoreCollectionComponent} from './store-collection.component';
import {StoreCollectionIndexComponent} from './store-collection-index/store-collection-index.component';
import {StoreCollectionFormComponent} from './store-collection-form/store-collection-form.component';
import {StoreCollectionEditComponent} from './store-collection-edit/store-collection-edit.component';
import {StoreCollectionCreateComponent} from './store-collection-create/store-collection-create.component';
import {CardModule} from '../../resources/components/card/card.module';
import {FormGroupContextModule} from '../../resources/modules/form-group-context/form-group-context.module';
import {FormGroupSimpleModule} from '../../resources/modules/form-group-context/form-group-simple/form-group-simple.module';
import {ValidateModule} from '../../resources/modules/validate/validate.module';
import {FormsModule, ReactiveFormsModule} from '@angular/forms';
import {TableStoreCollectionModule} from '../../resources/tables/table-store-collection/table-store-collection.module';
import {FormGroupSelectModule} from '../../resources/modules/form-group-context/form-group-select/form-group-select.module';
import {StoreCollectionViewComponent} from './store-collection-view/store-collection-view.component';
import {StoreCollectionViewInfoComponent} from './store-collection-view/store-collection-view-info/store-collection-view-info.component';
import {StoreCollectionViewPurchasesComponent} from './store-collection-view/store-collection-view-purchases/store-collection-view-purchases.component';
import {TablePurchaseModule} from '../../resources/tables/table-purchase/table-purchase.module';
import {TableUserModule} from '../../resources/tables/table-user/table-user.module';
import {RouterModule} from '@angular/router';
import {StoreCollectionRoutesModule} from './store-collection-routes/store-collection-routes.module';
import {BadgeExistModule} from '../../resources/components/badge-exist/badge-exist.module';
import {EntityLinkModule} from '../../resources/components/entity-link/entity-link.module';
import {SharedModule} from '../../modules/shared.module';
import {BtnDeleteModule} from '../../resources/components/btn-delete/btn-delete.module';
import {RouterOuterDirectiveModule} from "../../resources/directives/router-outer-directive/router-outer-directive.module";
import {TabsRouteModule} from "../../resources/components/tabs-route/tabs-route.module";


@NgModule({
  declarations: [
    StoreCollectionComponent,
    StoreCollectionIndexComponent,
    StoreCollectionFormComponent,
    StoreCollectionEditComponent,
    StoreCollectionCreateComponent,
    StoreCollectionViewComponent,
    StoreCollectionViewInfoComponent,
    StoreCollectionViewPurchasesComponent
  ],
  imports: [
    CommonModule,
    CardModule,
    FormGroupContextModule,
    FormGroupSimpleModule,
    ValidateModule,
    RouterModule,
    FormsModule,
    ReactiveFormsModule,
    StoreCollectionRoutesModule,
    TableStoreCollectionModule,
    FormGroupSelectModule,
    TablePurchaseModule,
    TableUserModule,
    BadgeExistModule,
    EntityLinkModule,
    SharedModule,
    BtnDeleteModule,
    RouterOuterDirectiveModule,
    TabsRouteModule
  ]
})
export class StoreCollectionModule {
}
